import React from 'react';

import './Sidebar.css';
import Slideshow from './Slideshow'

const Sidebar = ({data, selection, setSelection, setOpen}) => {

	const selectedIds = new Set(selection);
	const ffeatures = data['features'].filter(f => selectedIds.has(f.properties.id));
	const a = ffeatures.length > 0 ? ffeatures[0].properties : {};
	console.log(a)

	/* Set the width of the side navigation to 0 and the left margin of the page content to 0 */
	const closeNav =() => {
		setSelection([])
	}

	const getWidth = () => {
		if (selection.length > 0) return '300px';
		return "0";
	}

	return <React.Fragment>
		<div id="mySidenav" className="sidenav" style={{width: getWidth()}}>
		  	<div className="closebtn" onClick={closeNav}>&times;</div>
		  
		  	<Slideshow urls={(a.image_links || []).filter(l => l.trim() != '')} setOpen={setOpen}/>
		  	<div className="sidebarDetails">
		  		{data['properties']['columns'].map(k => {
		  			let content = a[k];
		  			if (!content || content === '') return '';
		  			if (String(content).startsWith('http') || String(content).startsWith('www')) {
		  				return <React.Fragment key={k}>
		  					<h6> {k} </h6>
		  					<a target="_blank" href={content}>{content}</a>
		  				</React.Fragment>
		  			}
		  			if (k.toLowerCase() === 'height') {
		  				return <React.Fragment key={k}>
			  				<h6> Height </h6>
			  				<p> {content} meters </p>
		  				</React.Fragment>
		  			}
		  			return <React.Fragment key={k}>
		  				<h6> {k} </h6>
		  				<p> {content} </p>
		  			</React.Fragment>

		  		})}
			</div>
		</div>
	</React.Fragment>
}


export default Sidebar;
